"use strict";

// ---------------------------------------------------
// Load Super Class

var SoaCollection = require('bunsen/collections/SoaCollection');

// ---------------------------------------------------
// Module Definition

/**
 * @class ItemAttributes
 * @extends SoaCollection
 */
var ItemAttributes = module.exports = SoaCollection.extend();

// ---------------------------------------------------
// Dependencies

var _ = require('underscore');
var ItemAttribute = require('bunsen/models/inventory/ItemAttribute');

// ---------------------------------------------------
// Local Vars

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(ItemAttributes.prototype, {
    model : ItemAttribute,
    comparator: 'value'
});

// ---------------------------------------------------
// Define Module Static Properties

_.extend(ItemAttributes, {

});


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/inventory/ItemAttributes.js
// module id = 1010
// module chunks = 63